import { STEPS } from '@astro/astrologer-forms'

/** Vertical step rail (horizontal scroller on mobile). Done steps are clickable. */
export default function StepNav({ currentStep, onStepClick }) {
  return (
    <div className="bg-linear-to-b from-stone-50/90 to-amber-50/40 border-b md:border-b-0 md:border-r border-stone-100 p-5 md:p-7">
      <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-stone-400 mb-6 hidden md:block">
        Application Steps
      </p>
      <ol className="flex md:flex-col gap-5 md:gap-0 overflow-x-auto md:overflow-visible no-scrollbar">
        {STEPS.map((step, i) => {
          const stepNumber = i + 1
          const state =
            stepNumber < currentStep ? 'is-done' : stepNumber === currentStep ? 'is-active' : ''
          const isLast = stepNumber === STEPS.length
          return (
            <li
              key={step.title}
              className={`stepnav-item ${state} flex items-center md:items-start gap-3.5 shrink-0${isLast ? '' : ' md:pb-8'}`}
            >
              <button
                type="button"
                onClick={() => stepNumber <= currentStep && onStepClick(stepNumber)}
                className={`flex flex-col items-center self-stretch${stepNumber <= currentStep ? ' cursor-pointer' : ' cursor-default'}`}
                aria-label={`Step ${stepNumber}: ${step.title}`}
              >
                <div className="stepnav-icon">{step.icon}</div>
                {!isLast && <div className="stepnav-line hidden md:block" />}
              </button>
              <div className="pt-1.5 hidden md:block">
                <p className="stepnav-title">{step.title}</p>
                <p className="stepnav-sub">{step.sub}</p>
              </div>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
